import gql from 'graphql-tag';

export default gql`
  mutation sendPasswordResetEmail ($input: SendPasswordResetEmailInput!) {
    sendPasswordResetEmail(input: $input)
  }
`;
